import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from "react-redux";
import {get, find} from 'lodash';
import classNames from 'classnames';

import {FILTER_1} from "../../../../../reducers/performance_reducers";
import {
    SetDashboardFiltersAction,
    CleanDashboardDataAction
} from "../../../../../actions/performance_actions";
import SelectionDataType from '../SelectionDataType';
import SkillGraph from '../SkillGraph';
import StudentGraph from '../StudentGraph';


export default function ({dataMode, setDataMode, dataType, setDataType}) {
    const dispatch = useDispatch();

    const dashboard_filters = useSelector(state => state.dashboard_filters);
    const dashboard_student_filter = useSelector(state => state.dashboard_student_filter);

    const filters = dashboard_filters[FILTER_1];

    useEffect(() => {
        if (dataType != 'math' && dataType != 'ela') {
            console.log('dataType', dataType);
            setDataType('math');
        }
    }, []);

    const renderStudents = () => {
        if (!dashboard_student_filter) {
            return null;
        }

        const selected_student_id = get(filters.student_id, 0);

        const onClick = (student_id) => () => {
            if (student_id == selected_student_id) {
                return;
            }
            const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
            if (student_id) {
                dashboard_filters_copy[FILTER_1]['student_id'] = [student_id];
            } else {
                dashboard_filters_copy[FILTER_1]['student_id'] = [];
            }
            dispatch(CleanDashboardDataAction());
            dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
        }

        const render_students = dashboard_student_filter.map((student) => {
            const class_names = classNames("pam-selection-one-item flex-row flex-gap-10", {
                "pam-selection-one-item-selected": student.student_id == selected_student_id
            });
            return (
                <div key={student.student_id} className={class_names} onClick={onClick(student.student_id)}>
                    <div>
                        {`${student.student_name}`}
                    </div>
                </div>
            );
        });

        const class_names_all = classNames("pam-selection-one-item", {
            "pam-selection-one-item-selected": selected_student_id == undefined
        });

        return (
            <div className="flex-auto pam-selection-scroll">
                <div className="flex-column flex-gap-5">
                    <div className={class_names_all} onClick={onClick(undefined)}>
                        {`All Students`}
                    </div>

                    {render_students}
                </div>
            </div>
        );
    }

    const renderData = () => {
        const selected_student_id = get(filters.student_id, 0);
        if (!selected_student_id) {
            return (
                <SkillGraph
                    dataType={dataType}
                />
            );
        }

        const selected_student = find(dashboard_student_filter, {student_id: selected_student_id});
        const student_name = get(selected_student, 'student_name');

        switch (dataType) {
            case 'math':
            case 'ela':
            default:
                return (
                    <StudentGraph
                        dataType={dataType}
                        student_name={student_name}
                    />
                );
        }
    }

    const onClose = () => {
        if (filters['student_id'].length > 0) {
            dispatch(CleanDashboardDataAction());
            const dashboard_filters_copy = JSON.parse(JSON.stringify(dashboard_filters));
            dashboard_filters_copy[FILTER_1]['student_id'] = [];
            dispatch(SetDashboardFiltersAction(dashboard_filters_copy));
        }
        setDataMode('general')
    }

    return (
        <div className="flex-row flex-gap-10">
            <div className="pam-component pam-selection-part pam-selection-middle flex-column">
                <div className="pam-selection-header">
                    {`Students`}
                </div>
                {renderStudents()}
                <i className="pam-selection-part-close fas fa-times" onClick={onClose}></i>
            </div>

            <div className="flex-auto pam-component pam-selection-part pam-selection-right">
                <SelectionDataType
                    dataMode={dataMode}
                    dataType={dataType}
                    setDataType={setDataType}
                />

                <div className="divider"></div>

                <div>
                    {renderData()}
                </div>
            </div>
        </div>
    );
}
